var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContractDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "contract_delete"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4332_38785",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.666504,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4332_38785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "contract_delete_2",
    d: "M19.7628 18.8095L17.6378 20.9288L16.93 20.2213L19.0493 18.0962L16.93 15.9712L17.6378 15.2635L19.7628 17.3828L21.8878 15.2635L22.5953 15.9712L20.476 18.0962L22.5953 20.2213L21.8878 20.9288L19.7628 18.8095ZM6.6665 21C6.10234 21 5.628 20.8077 5.2435 20.423C4.85884 20.0385 4.6665 19.5642 4.6665 19V16.2308H7.6665V3H20.6665V12.298C20.5037 12.2583 20.3389 12.2318 20.1723 12.2183C20.0056 12.2048 19.837 12.198 19.6665 12.198V4H8.6665V16.2308H14.1895C14.137 16.3936 14.0912 16.5552 14.052 16.7155C14.013 16.8757 13.9807 17.0474 13.955 17.2308H5.6665V19C5.6665 19.2833 5.76234 19.5208 5.954 19.7125C6.14567 19.9042 6.38317 20 6.6665 20H14.1895C14.246 20.191 14.3198 20.3667 14.4108 20.527C14.5018 20.6872 14.5973 20.8448 14.6973 21H6.6665ZM10.051 8.3845V7.3845H18.282V8.3845H10.051ZM10.051 11.1538V10.1538H18.282V11.1538H10.051ZM14.1895 20H5.6665H13.955H13.8953H14.1895Z",
    fill: "#15B79E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractDeleteIcon);
export default __webpack_public_path__ + "static/media/contract-delete-icon.106d39bc9839656c56d58695c5b3817d.svg";
export { ForwardRef as ReactComponent };